// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"e36a6843","3575":"ce044c50","4935":"08d55499","6782":"e36a6843","7425":"e36a6843","9359":"e36a6843"}[chunkId] + ".chunk.css";
};